import React from 'react'
import { withTranslation } from 'react-i18next'
import { setLog, types } from '../../utilities/LogError'
import { clearAuth } from '../../../api/api'
import { revokeSessionOnServer } from '../../../auth/revokeSession'
import LayoutError from '../LayoutError/LayoutError'
import LogoutIcon from '@mui/icons-material/Logout'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'


import './ErrorBoundary.sass'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(e, { componentStack }) {
    const params = {
      type: types.GLOBAL_ERROR,
      title: e.toString(),
      stack: componentStack
    }

    setLog(params)
  }

  handleLogout = async () => {
    // Antes de `clearAuth()`: el DELETE se autentica con esos tokens. Sin esto
    // el `client` quedaba huérfano en `users.tokens` y contaba para el tope de
    // dispositivos. Nunca lanza (best-effort con timeout).
    await revokeSessionOnServer()
    clearAuth()
    localStorage.removeItem('persist:root')
    sessionStorage.clear()
    window.location.href = '/login'
  }

  getErrorMessage = () => {
    const { t } = this.props
    return (
      <LayoutError>
        <div className='ErrorBoundary'>
          <div className="image-box">
            <div className='text-wrapper'>
              <h1>{t('sorry')},</h1>
              <h2>{t('an error occurred')}</h2>
            </div>
            <img
              src="./404_error.svg"
              alt={t("404 error illustration")}
            />
          </div>

          <Stack spacing={1} direction="column" className="refresh-box">
            <div className='button-refresh'>
              <IconButton
                color="primary"
                onClick={this.handleLogout}
              >
                <LogoutIcon />
              </IconButton>
            </div>
            <p className='text-refresh'>
              {t('we recommend signing in again')}
            </p>
          </Stack>
        </div>
      </LayoutError>
    )
  }

  render() {
    if (this.state.hasError) return this.getErrorMessage()
    return this.props.children
  }
}


export default withTranslation()(ErrorBoundary)
